import { Theme } from 'config';

const styles = (theme: Theme) => ({
  container: {
    border: 'none !important',
    margin: '.625rem 0 !important',
    padding: '1.25rem !important',
    width: '100% !important',
    position: 'relative !important',
  },
  formGrid: {
    margin: '0 !important',
  },
  formRow: {
    padding: '.5rem 0 !important',
  },
  fieldLabel: {
    color: '#646464 !important',
    fontSize: '.875rem !important',
    fontWeight: '500 !important',
    margin: '0 0 .30rem 0',
    display: 'block !important',
  },
  fieldInput: {
    display: 'flex',
    maxWidth: '100%',
    width: '100%',
    textAlign: 'left',
    margin: '0 .25rem 0 0',
    outline: '0',
    tapHighlightColor: 'rgba(255,255,255,0)',
    lineHeight: '1.21em',
    padding: '.67857143rem 1rem',
    fontSize: '1em',
    background: '#fff',
    border: '.0625rem solid rgba(34,36,38,.15)',
    color: 'rgba(0,0,0,.87)',
    borderRadius: '.28571429rem',
    boxShadow: '0 0 0 0 transparent inset',
    transition: 'color .1s ease,border-color .1s ease',
  },
  button: {
    backgroundColor: `${theme.violet} !important`,
    borderRadius: '1.5em !important',
    color: '#fff !important',
    marginTop: '1rem !important',
    height: '3.125rem',
    fontWeight: 'bold !important',
    width: '100%',
    outline: 0,
    border: 'none !important',
    '&:hover': {
      boxShadow:
        '0 0 0 .0625rem transparent inset,0 0 0 0 rgba(34,36,38,.15) inset !important',
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  buttonSecondary: {
    marginRight: '.45rem !important',
    backgroundColor: `${theme.softGray} !important`,
    color: `${theme.darkGray} !important`,
    height: '3.125rem',
    '&:hover': {
      boxShadow:
        '0 0 0 .0625rem transparent inset,0 0 0 0 rgba(34,36,38,.15) inset !important',
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  mediumBtn: {
    width: '48% !important',
  },
});

export default styles;
